module.exports = __webpack_public_path__ + "assets/img/chronicleImg-ad9c7283.png";